import { Component, OnInit, Input} from '@angular/core';

import { BackendService } from '../../core/backend.service';
import { ProductosBuscadoHistorial } from './models/producto-buscado-historial.model';
import { Observable, Observer, Subject, Subscription } from 'rxjs';
import { Actions, GenericListComponent, HasAction, Page } from '../../shared-components/generic-list/generic-list.component';
import { MediaService } from '../../shared-services/media.service';
import { MatPaginatorIntl } from '@angular/material';
import { filter } from 'lodash';
import { Router } from '@angular/router';
import { Proveedor } from '../proveedor/proveedor.model';
import { SecurityService } from '../../security/security.service';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { SnackService } from '../../shared-services/snack.service';
import { ISelectedChip } from '../../cliente/cliente-filter.component';
import { ProductosBuscadoAgrupadoHistorial } from './models/producto-buscado-agrupado-historial.model';



interface Filters {
  description: string;
  page: number;
  size: number;
  search?: string;
}

@Component({
  selector: 'app-productos-buscados',
  templateUrl: './productos-buscados.component.html',
  styleUrls: ['./productos-buscados.component.scss']
})
export class ProductosBuscadosComponent implements OnInit {

  selectedChips: ISelectedChip[] = [];

  private filters: Filters = {
    description: undefined,
    page: 0,
    size: 10,
  };

  /*columns = [
    { name: 'id',  label: 'ID' },
    { name: 'texto',  label: 'Nombre' },
    { name: 'encuentraProductos',  label: 'Se encontró el producto' },
  ];*/

  columns = [
    { name: 'texto',  label: 'Texto' },
    { name: 'cantidad',  label: 'cantidad' },
    { name: 'encontrado',  label: 'Se encontró el producto' },
  ];

  private genericListComponent: GenericListComponent;

  public totalItems: number;
  private getNewPage = new Subject<Filters>();

  listaProductosBuscados: ProductosBuscadoAgrupadoHistorial[];

  public showFilters = true;
  isMobile: boolean;

  roleFiltersActive = false;
  mostrarResumen = false;
  isLoading = false;
  filtersActive = false;
  public hasActions: HasAction;
  filtersLoaded = false;
  subscriptions: Subscription[] = [];


  itemsList = this.backendService.newSubjectWithoutDistinct<Filters>()
  .switchMap(filters => {
    const proveedoresPromise = this.backendService.get(ProductosBuscadoAgrupadoHistorial, ProductosBuscadoAgrupadoHistorial.path + 'historial-busqueda/', filters).toPromise();

    return (async () => {
      this.isLoading = true;
      try {
        const proveedores = await proveedoresPromise;
        return proveedores;
      } catch (error) {
        return [];
      }
      finally {
        this.isLoading = false;
        this.filtersActive = !(this.filters.search === '' || this.filters.search === undefined);
      }
    })();
  }).share() as Observer<Filters> & Observable<ProductosBuscadoAgrupadoHistorial[]>;


  constructor(
    private backendService: BackendService,
    private mediaService: MediaService,
    private paginatorsLabels: MatPaginatorIntl,
    private router:Router,
    public securityService: SecurityService,
    private dialogService:DialogService,
    private snackService:SnackService
  ) {}

  ngOnInit() {

    this.showFilters = true;
    this.filtersLoaded = true;

    this.hasActions = new HasAction();

    this.hasActions.hasAction = true;
    this.hasActions.actions = [{ 'element': Actions.edit, 'permission': 'EDITAR_PROVEEDOR'},
                              { 'element': Actions.delete, 'permission': 'ELIMINAR_PROVEEDOR'}];

    this.subscriptions.push(this.mediaService.isMobile.subscribe(isMobile => {
      this.isMobile = isMobile;
      this.showFilters = !this.isMobile;
    }));

    this.paginatorsLabels.itemsPerPageLabel = 'Filas por página:';

    this.itemsList.subscribe(t => {
      this.isLoading = false;
      this.totalItems = t['totalItems'];
    });

    this.refreshItemsList();
  }

  getDefaultFilters() {
    this.filters = {
      description : undefined,
      page: 0,
      size: 10,
    };
  }

  refreshItemsList() {
    this.itemsList.next(this.getFilters());
  }

    getFilters() {
    return this.filters;
  }

  async getListProducts() {
    this.listaProductosBuscados = await this.backendService.get(ProductosBuscadoAgrupadoHistorial, ProductosBuscadoAgrupadoHistorial.path + 'all-product-database', null).toPromise();
  }


  descargarCSV(): void {

    this.getListProducts().then(a=>{
      // Convertir los datos a formato CSV
      let csvData = this.convertToCSV(this.listaProductosBuscados);

      // Crear un enlace para la descarga
      let blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
      let url = window.URL.createObjectURL(blob);

      // Crear un elemento temporal <a> y hacer clic en él para iniciar la descarga
      let tempLink = document.createElement('a');
      tempLink.href = url;
      tempLink.setAttribute('download', 'ProductosBuscados.csv');
      tempLink.style.visibility = 'hidden';
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
    });
    
  }



  convertToCSV(objArray: any[]): string {
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = '';
    debugger
    // Extraer los encabezados y excluir los de las posiciones 2 y 3
    let headers = Object.keys(objArray[0]).filter((header, index) => index !== 2 && index !== 3);
  
    // Nombres personalizados para los encabezados
    const customHeaders = ['texto', 'cantidad', 'encontrado'];
  
    // Reemplazar los encabezados originales con los personalizados, manteniendo la exclusión de las pocisiones 2 y 3 (update and delete)
    for (let index in headers) {
      row += customHeaders[index] + ';';
    }
    debugger
    row = row.slice(0, -1);
    str += row + '\r\n';
  
    // Recorrer cada objeto
    for (let i = 0; i < array.length; i++) {
      let line = '';
      headers.forEach((header, index) => {
        if (line !== '') line += ';';
  
        // Obtener el valor y convertir booleanos a 'SI'/'NO'
        let value = array[i][header];
        if (typeof value === 'boolean') {
          value = value ? 'SI' : 'NO';
        } else if (typeof value === 'string') {
          // Escapar comillas dobles
          value = value.replace(/"/g, '""');
        }
  
        // Agregar un tabulador al principio del primer valor
        if (index === 0) {
          line += '\t';
        }
        line += value;
      });
      str += line + '\r\n';
    }
    debugger
    return str;
  }

   // Seteo de filtros
   toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  onPageChange(page: Page) {
    this.filters.page = page.pageIndex;
    this.filters.size = page.pageSize;
    this.refreshItemsList();
  }

  onSearch(searchText) {
    this.filters.search = 'texto:' + searchText;
    this.refreshItemsList();
  }

  clearSearch() {
      this.refreshItemsList();
  }

  getData(response: Response) {
    const data = response.json();
    if (response.ok) { return data; }
    throw data['hydra:description'] || data['message'];
  }

  displayFilters(boolean: boolean) {
    this.showFilters = boolean;
  }

  onAdd() {
    //this.router.navigate(['/proveedores/agregar']);
  }


  onEdit(p: ProductosBuscadoHistorial) {
    //this.router.navigate(['/proveedores/editar', p.id]);
  }

  async onDelete(busqueda: ProductosBuscadoHistorial) {

    this.dialogService.confirm('Eliminar busqueda',
    '¿Está seguro que desea eliminar la busqueda ' + busqueda.texto + '?')
    .then( res => {
      if (res) {
        this.deleteProductoBusqueda(res, busqueda);
      }
    });


  }

  async deleteProductoBusqueda(res, busqueda: ProductosBuscadoHistorial) {

    if (res) {

      this.snackService.spinner(true);

      try {
        await this.backendService.delete(ProductosBuscadoHistorial.path + "historial-busqueda/" + busqueda.id);
        this.snackService.success('Busqueda eliminada correctamente');
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
        this.refreshItemsList();
      }

    }

  }
  async onFiltersChanged(event) {
    this.selectedChips = event;
    this.filters.search = await this.buildSearch(this.selectedChips);
    this.refreshItemsList();
  }

  buildSearch(chips: ISelectedChip[]) {
    let searchString: string;
    searchString = this.buildSearchFilter(chips.filter(x => x.categoryName === 'Estado del pedido'), 'estado.id', false, ':');
    searchString += this.buildSearchFilter(chips.filter(x => x.categoryName === 'Última compra'), 'fecha', false, '>');
    searchString += this.buildSearchFilter(chips.filter(x => x.categoryName === 'Encuentra'), 'encuentraProductos', true, ':');
   /*  searchString = this.buildSearchFilter(chips.filter(x => x.categoryName === 'Situación IVA'), 'situacionIva.id', false);
    searchString += this.buildSearchFilter(chips.filter(x => x.categoryName === 'Última conexión'), 'ultimoLogin', false, '#');
    searchString += this.buildSearchFilter(chips.filter(x => x.categoryName === 'Fecha de última compra'), 'ultimaCompra', false, '>');
    searchString += this.buildSearchFilter(chips.filter(x => x.categoryName === 'Origen de Usuario'), 'origen', false);
    searchString += this.buildSearchFilter(chips.filter(x => x.categoryName === 'Provincias'), 'direcciones.provincia.id', false);
    searchString += this.buildSearchFilter(chips.filter(x => x.categoryName === 'Países'), 'direcciones.pais.id', false);
    searchString += this.buildSearchFilter(chips.filter(x => x.categoryName === 'Localidad'), 'direcciones.localidad', true); */
    /*if (this.nameSearch) {
      searchString += 'id:' + this.nameSearch + ',';
    }*/

    return searchString;
  }

  buildSearchFilter(chips: ISelectedChip[], categoryName: string, filterLike: boolean, operator: string = ':') {
    if (chips.length > 0) {
      let search = filterLike ? categoryName + operator : categoryName + operator + '[';
      let flag = false;
      for (const chip of chips) {
        if (flag) {
          search += ',';
        }
        search += chip.tagId;
        flag = true;
      }
      return filterLike ? search += ',' : search += '],';
    }
    return '';
  }
  
}




// WEBPACK FOOTER //
// ./src/app/productos/productos-buscados/productos-buscados.component.ts